/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespRefineMenuStoneCutSelect_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespRefineMenuFilterStoneCut_searchBrowse$ref: FragmentReference;
export type SbRespRefineMenuFilterStoneCut_searchBrowse = {|
  +$fragmentRefs: SbRespRefineMenuStoneCutSelect_searchBrowse$ref,
  +$refType: SbRespRefineMenuFilterStoneCut_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterStoneCut_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuStoneCutSelect_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4e8cb851930cb0e755a40664b157dcfb';
module.exports = node;
